import React from 'react';
import { Switch } from 'react-router-dom';
import SignIn from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import ForgotPassword from '../pages/ForgotPassword';
import NotFound from '../pages/NotFound';
import Home from '../pages/Home';
import CollectType from '../pages/CollectType';
import CollectRequesterType from '../pages/CollectRequesterType';
import DeclarationForm from '../pages/DeclarationForm';
import DefaultCollect from '../pages/DefaultCollect';
import ReverseCollect from '../pages/ReverseCollect';
import GeneralShippingGuidelines from '../pages/GeneralShippingGuidelines';
import ProfileCollect from '../pages/ProfileCollect';
import MyAccount from '../pages/MyAccount';
import MyCollections from '../pages/MyAccount/pages/MyCollections';
import SearchMyCollections from '../pages/MyAccount/pages/SearchMyCollections';
import Route from './Route';

const Routes = () => (
  <Switch>
    <Route path="/" exact component={Home} />
    <Route path="/signin" component={SignIn} />
    <Route path="/signup" component={SignUp} />
    <Route path="/forgot-password" component={ForgotPassword} />
    <Route
      path="/acesso-rapido/pedido-de-coleta-perfil"
      exact
      component={ProfileCollect}
      isPrivate
    />
    <Route
      path="/acesso-rapido/tipo-de-coleta"
      exact
      component={CollectType}
      isPrivate
    />
    <Route
      path="/acesso-rapido/tipo-de-solicitante"
      exact
      component={CollectRequesterType}
      isPrivate
    />
    <Route
      path="/acesso-rapido/orientacoes-gerais-de-transporte"
      exact
      component={GeneralShippingGuidelines}
      isPrivate
    />
    <Route
      path="/acesso-rapido/pedido-de-coleta/padrao"
      exact
      component={DefaultCollect}
      isPrivate
    />
    <Route
      path="/acesso-rapido/pedido-de-coleta/declaracao"
      exact
      component={DeclarationForm}
      isPrivate
    />
    <Route
      path="/acesso-rapido/pedido-de-coleta/reversa"
      exact
      component={ReverseCollect}
      isPrivate
    />
    <Route
      path="/area-do-cliente/minha-conta"
      exact
      component={MyAccount}
      isPrivate
    />
    <Route
      path="/area-do-cliente/minha-conta/minhas-coletas"
      exact
      component={MyCollections}
      isPrivate
    />
    <Route
      path="/area-do-cliente/minha-conta/search-minhas-coletas"
      exact
      component={SearchMyCollections}
      isPrivate
    />
    <Route path="*" component={NotFound} />
  </Switch>
);

export default Routes;
